<template>
    <div class="banner" v-show="showModal">
        <div class="inner">
            <p>주차요금 정산! 새로워진 <span>통합주차포털</span> 에서 해결하세요</p>
            <button type="button" class="bCloseBtn"  @click="modalHide"  @keydown.enter="modalHide"><span class="hidden">닫기</span></button>
        </div>
    </div>
</template>

<script>
export default {
	data(){
		return{
			showModal  : true,
		}
	},

	methods: {
	
		modalHide(){
			this.showModal = false;
		},
	
	},
	
}
</script>

<style>

</style>